module.exports = __webpack_public_path__ + "img/Ellipse 12.7273f81e.svg";